import React from 'react'
import SinglePageRenderer from '../SinglePageRenderer'

const ImprintPage = () => (
	<SinglePageRenderer paddingTop={70} title="SN - News" pageId="news" />
)

export default ImprintPage
